import React, { useEffect, useRef } from 'react';

interface ThreeDSecureModalProps {
    htmlContent: string;
    onClose?: () => void;
}

const ThreeDSecureModal: React.FC<ThreeDSecureModalProps> = ({ htmlContent, onClose }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        if (iframeRef.current) {
            const doc = iframeRef.current.contentDocument;
            if (doc) {
                doc.open();
                doc.write(htmlContent);
                doc.close();
            }
        }
    }, [htmlContent]);

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-white rounded-2xl w-full max-w-lg overflow-hidden shadow-2xl relative">
                <div className="p-4 border-b flex justify-between items-center bg-gray-50">
                    <h3 className="font-bold flex items-center gap-2">
                        <span>🔒</span>
                        3D Secure Doğrulama
                    </h3>
                    {onClose && (
                        <button
                            onClick={onClose}
                            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-red-100 hover:text-red-500 flex items-center justify-center transition-all"
                        >
                            ✕
                        </button>
                    )}
                </div>

                <div className="h-[500px] w-full bg-white">
                    <iframe
                        ref={iframeRef}
                        className="w-full h-full border-0"
                        title="3D Secure Verification"
                    />
                </div>
            </div>
        </div>
    );
};

export default ThreeDSecureModal;
